module.exports = __webpack_public_path__ + "toGroom-jp-w-w.775a2e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-jp-w-w.jpg
// module id = VS2j
// module chunks = 0